export const FALLBACK_AVATAR_URL = '/assets/imgur/C3a3S1X.png';

export const ROBLOX_TIPS = [
  'Roblox существует уже 18 лет! Впервые в игру сыграли 1 сентября 2006 года.',
  'Изначально игра называлась Dynablocks, но Roblox звучит круче, не правда ли?',
  'В Roblox есть своя валюта — Robux.',
  'Пользователи Roblox могут создавать собственные игры и другой контент.',
  'Roblox Studio бесплатна и подходит начинающим разработчикам.',
  'Одной из самых популярных игр Roblox считается Adopt Me!',
  'Программа DevEx позволяет разработчикам обменивать заработанные Robux на деньги.',
];

export const PRELOAD_IMAGE_URLS = [
  'nKvLOJA.jpg','Jpeqr1B.jpg','ZBKKqoo.jpg','Tk10S1F.jpg','Mg3D2k5.jpg',
  'GtEV9PY.jpg','trKt7gV.jpg','ygKznIk.png','BsvmDaa.png','si0rwZM.png','ly2xLQv.png',
  '6gQdDtR.png','lHrmKZq.png','IQiX3tS.png','AyN2XWK.png','j4eGJhS.png','tbYGaby.png',
  'bqfSBQi.png','dr13M3o.png','y9DZRmJ.png','l390H4Y.png','HGizS9F.png','xlhFB2w.png',
  'qhwipuV.jpg','nZZyTZx.png','EogKJ6D.jpg','C3a3S1X.png','1Q9Dv2v.png',
  'Z5c8twN.png','7xBMlBK.jpg','L6omUiw.jpg','A8tbZyv.png','PL3y6wD.jpg','cQJVsoP.jpg',
  'JxRgaGo.jpg','dyyDujv.jpg','T0v2LbV.jpg','oygMjCB.jpg','DvrE0rV.jpg','lgdFSue.jpg',
  'dS90O75.jpg','ycoYYHS.jpg','m9TNpcn.jpg','t2HeVTb.png','Fnc9rTt.png','cgcbt1L.png',
  'burtHQa.png','1xowmWK.png','G4Xf4r6.png','xFnnAEl.png','ch0F8sA.png','sz9wtnW.png',
  '5fXFqf6.png','zi1SM9m.png','t8KDKK4.png','luxKr7c.png','Ue8K3q5.png','b8UykvS.png',
  'RM0LfTK.png','RlTPH1f.png','or5RB36.png','lJgACSF.png','zTdCips.png','eL7tDMO.jpg',
].map((fileName) => `/assets/imgur/${fileName}`).concat([
  '/assets/nav-clicker-v2.png',
  '/assets/nav-shop-v2.png',
  '/assets/nav-friends-v2.png',
  '/assets/nav-quests-v2.png',
  '/assets/nav-profile-v2.png',
  '/assets/currency-coin-v2.png',
  '/assets/currency-diamond-v2.png',
  '/assets/rank-trophy-v2.png',
]);
